export default {
  data () {
    return {
      pallete: {
        $active_color: '#008594',
        $safe_color: '#1f9ec4',
        $dangerous_color: '#ff5252',
        $secondary_active_color: '#83f4ff',
        $primary_text_color: '#fff',
        $secondary_text_color: '#999',
        $secondary_bg_color: '#1b1820',
        $primary_bg_color: '#252127',
      }
    }
  },
  methods: {
    sleep (msec) {
      return new Promise(resolve => setTimeout(resolve, msec))
    }
  }
}
